import { useEffect, useRef, useState } from 'react';
import { partnersContent } from '@/mocks/home';

function useInView<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.unobserve(el); } },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return { ref, inView };
}

export default function PartnersSection() {
  const { ref: sectionRef, inView } = useInView<HTMLDivElement>();

  return (
    <section className="relative bg-background-50 py-12 md:py-20 overflow-hidden" ref={sectionRef}>
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1200px] mx-auto">
        {/* Title */}
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs md:text-sm font-semibold text-foreground-400 uppercase tracking-widest font-label">
            {partnersContent.titleEn}
          </span>
          <h2 className="mt-1 text-2xl md:text-3xl font-black text-foreground-50">
            {partnersContent.titleCn}
          </h2>
          <div className="mt-4 w-12 h-0.5 bg-primary-500 rounded-full mx-auto" />
        </div>

        {/* Partner Logo Cards */}
        <div className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-6 xl:gap-8 max-w-[1400px] mx-auto transition-all duration-700 delay-200 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {partnersContent.partners.map((partner, index) => (
            <div
              key={index}
              className="group relative flex items-center justify-center bg-background-100 border border-background-200 rounded-xl p-4 md:p-5 aspect-[4/3] overflow-hidden hover:border-primary-300 transition-all duration-300"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className={`w-full h-full object-contain transition-transform duration-300 ${partner.name === '保乐力加中国' ? 'scale-[1.4] group-hover:scale-[1.5]' : 'group-hover:scale-105'}`}
                title={partner.name}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}